import * as React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import AuthPage from "./AuthPage/AuthPage";
import RegisterPage from "./RegisterPage/RegisterPage";
import PasswordResetPage from "./PasswordResetPage/PasswordResetPage";
import EmailConfirmedPage from "./EmailConfirmedPage/EmailConfirmedPage";
import RegisterCompletePage from "./RegisterCompletePage/RegisterCompletePage";
import PasswordResetRequestPage from "./PasswordResetRequestPage/PasswordResetRequestPage";
import NewLinkPage from "./NewLinkPage/NewLinkPage";
import { useRouteMatch } from "react-router";
import PasswordAddPage from "./PasswordAddPage/PasswordAddPage";
import ExpiredPasswordPage from "./ExpiredPasswordPage/ExpiredPasswordPage";


const AuthRouter: React.FC = () => {
  let { path } = useRouteMatch();
  
  return (
    <Switch>
      <Route exact path={`${path}/sign-in`} component={AuthPage} />
      <Route exact path={`${path}/sign-up`} component={RegisterPage} />
      <Route exact path={`${path}/password-reset`} component={PasswordResetPage} />
      <Route exact path={`${path}/password-add`} component={PasswordAddPage} />
      <Route exact path={`${path}/email-confirm-result`} component={EmailConfirmedPage} />
      <Route exact path={`${path}/register-complete`} component={RegisterCompletePage} />
      <Route exact path={`${path}/password-reset-request`} component={PasswordResetRequestPage} />
      <Route exact path={`${path}/request-new-link`} component={NewLinkPage} />
      <Route exact path={`${path}/password-expired`} component={ExpiredPasswordPage}/>
      <Redirect from="*" to={`${path}/sign-in`} />
    </Switch>
  );
};

export default AuthRouter;
